import React, { useState } from 'react';
import Modal from '../Modal';
import { useAssets } from '../../Data/Assets';
import { PageLoading } from '../Loading';
import Icon from '../Icons/Icon';
import { useNewWindow } from '../../Services/helpers';
import ButtonRow from '../Button/ButtonRow';
import Button from '../Button/Button';

const Gallery = ({assetIds, title, isOpen, setIsOpen, initialAssetId}) => {
    return <Modal title={title ?? 'Attachments'} {...{isOpen, setIsOpen}} fullHeight dismissible>
        {isOpen && <Inner {...{assetIds, initialAssetId}} />}
    </Modal>
}

const Inner = ({assetIds, initialAssetId}) => {
    const {assets, isLoading} = useAssets(assetIds);
    const newWindow = useNewWindow();
    const [selectedId, setSelectedId] = useState(initialAssetId || assetIds[0]);

    if (isLoading) {
        return <PageLoading />;
    }

    const selectedAsset = assets.find(asset => asset.id === selectedId);
    const isImage = selectedAsset.mime?.startsWith('image/');
    const isVideo = selectedAsset.mime?.startsWith('video/');

    return (
        <div className="flex flex-col gap-4 min-h-0 h-full pb-4 flex-1">

            {isImage && <div className="relative flex-1 flex items-center justify-center rounded-lg min-h-12">
                <div className="absolute w-full h-full z-10 flex justify-center items-center">
                    <Icon
                        icon="Camera"
                        size="6x"
                        className="fill-light z-0"
                    />
                </div>
                <div className="max-h-full max-w-full relative z-10 rounded-lg overflow-scroll no-scrollbar p-2 border">
                    <img
                        key={selectedAsset.id}
                        src={selectedAsset.original}
                        className="max-h-full max-w-full rounded-lg object-contain"
                        alt={selectedAsset.id}
                        onClick={() => newWindow(selectedAsset.original)}
                    />
                </div>
            </div>}
            {isVideo && <div className="relative flex-1 flex items-center justify-center rounded-lg min-h-12">
                <div className="max-h-full max-w-full relative z-10 rounded-lg overflow-scroll no-scrollbar p-2 border">
                    <video
                        key={selectedAsset.id}
                        src={selectedAsset.original}
                        className="max-h-full max-w-full rounded-lg object-contain"
                        controls
                    />
                </div>
            </div>}
            {!isImage && !isVideo && <div className="relative flex-1 flex flex-col gap-2 items-center justify-center rounded-lg min-h-6">
                <ButtonRow>
                    <Button icon="CloudArrowDown"
                        theme="primary"
                        label="Download File"
                        onClick={() => newWindow(selectedAsset.original)}
                    />
                </ButtonRow>
                <p className="text-sm text-muted text-center">{selectedAsset.filename}</p>
            </div>}

            <div className="h-auto flex gap-2 overflow-y-visible overflow-x-auto pb-1 no-scrollbar">
                {assets.map(asset => (
                    <div
                            key={asset.id}
                            className={`
                            w-24 h-24 shrink-0 border p-1 rounded-md overflow-hidden
                            cursor-pointer hover:border-brand
                            ${selectedId === asset.id ? 'border-brand' : 'border-gray-200'}
                        `}
                        onClick={() => setSelectedId(asset.id)}
                    >
                        <img
                            src={asset.thumbnail}
                            alt={asset.id}
                            className="w-full h-full object-cover rounded-md"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Gallery;
